<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="header-title">
            <h4 class="m-0 title-modal">Termos de Uso</h4>
          </div>
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>

        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="mt-3">
              <b>
                Termos e Condições Gerais de Uso do Site e Aplicativos da OZ
                CORRETORA DE CÂMBIO </b
              ><br /><br />

              <b>
                TERMOS E CONDIÇÕES GERAIS DE USO DE PLATAFORMAS ON-LINE (SITE,
                APP) </b
              ><br /><br />

              <p>
                Termos e Condições Gerais de Uso de Plataformas On-line (Site e
                Aplicativo) que tratam os serviços oferecidos por
                <strong>OZ CORRETORA DE CÂMBIO S.A.</strong>, pessoa jurídica de
                direito privado com sede sito à Rua Tenerife, no. 31, 3º andar –
                Vila Olímpia – São Paulo, SP inscrita no Castro Nacional da
                Pessoa Jurídica do Ministério da Fazenda sob n.º
                04.602.902/0001-03 doravante denominada <b>“CORRETORA”</b>,
                através de plataforma oferecida por
                <strong>XAVI PAY INSTITUIÇÃO DE PAGAMENTO LTDA</strong>, pessoa
                jurídica de direito privado com sede sito à Av. Marcos Penteado
                de Ulhoa Rodrigues, no. 1119, Conj. 1506 – Tamboré – Barueri,
                SP, inscrita no Castro Nacional da Pessoa Jurídica do Ministério
                da Fazenda sob n.º 39.157.329/0001-04 doravante denominada
                <b>“XPAY”</b>, aos <b>“CLIENTES”</b> que utilizem as plataformas
                “online” para contratação dos “Serviços”, conforme definido na
                cláusula 1, abaixo.
              </p>

              <p>
                O cliente declara ter lido o conteúdo deste termo e aceito
                integralmente seu conteúdo, estando ciente que ao aderir ao
                mesmo, todos os seus direitos e obrigações ficarão a ele
                vinculados. Estão incluídos ao presente Termo todas as regras
                aplicáveis à matéria, em especial o regulamento de mercado de
                câmbio e capitais internacionais originadas do Banco Central.
              </p>

              <b>1. DEFINIÇÕES</b>

              <p>
                <strong>1.1. CORRETORA:</strong> Instituição Financeira
                autorizada pelo Banco Central do Brasil a operar no mercado de
                câmbio que será responsável pela realização das operações
                cambiais requeridas pelos Clientes.
              </p>

              <p>
                <strong>1.2. XPAY:</strong> Sociedade Limitada fornecedora de
                software para a <b>CORRETORA</b> em suas operações de câmbio e
                demais que se façam necessárias.
              </p>

              <p>
                <strong>1.3. Moeda Nacional:</strong> Moeda oficial de curso
                forçado e obrigatória no território brasileiro.
              </p>

              <p>
                <strong>1.4. Moeda Estrangeira:</strong> Toda e qualquer moeda
                vigente em outra Federação ou Estado Internacional (país) com o
                qual a <b>CORRETORA</b> realize trocas financeiras pelo seu
                contra valor em moeda nacional.
              </p>

              <p>
                <strong>1.5. Cliente:</strong> Pessoa física ou jurídica, assim
                consideradas nos termos da legislação brasileira, signatária do
                presente Termo e que possua capacidade jurídica para prática dos
                atos necessários à vida civil e pelo cumprimento integral de
                todas as obrigações contraídas neste instrumento, bem como
                demais instrumentos e regulamentos aplicáveis à matéria.
              </p>

              <p>
                <strong>1.6. Plataforma online:</strong> Sítio eletrônico ou
                aplicativo de celular e/ou tablet de propriedade de terceiros ou
                da <b>CORRETORA</b> onde haja disponibilização de sistema
                “online” para requerimento de operações financeiras solicitadas
                a pedido do Cliente mediante utilização de software de
                propriedade intelectual da <b>XPAY</b>.
              </p>

              <p>
                <strong>1.7. Sistema:</strong> Software individual e/ou conjunto
                de softwares que sejam disponibilizados pela <b>CORRETORA</b> a
                terceiros mediante acordo comercial e que viabilizem a
                realização da prestação de serviços contratadas pelos Clientes
                conforme haja manifestação de vontades.
              </p>

              <b>2. OBJETO</b>

              <p>
                <strong>2.1.</strong> Regular o cadastro digital dos Clientes
                nas plataformas on-line da <b>CORRETORA</b> e as condições para
                viabilização da prestação de serviços no mercado financeiro pela
                <b>CORRETORA</b> ao Cliente contemplando todos os serviços por
                ela disponibilizados, quais sejam (Serviços):
              </p>

              <b>SITE E APP</b>
              <ul>
                <li>
                  <b>a) </b>
                  Compra e/ou venda de moeda estrangeira através de plataforma
                  digital;
                </li>
                <li><b>b) </b>Recepção e processamento de documentos;</li>
                <li><b>c) </b>Cadastro 100% digital;</li>
                <li>
                  <b>d) </b>Processamento e liquidação de pagamentos das
                  operações de câmbio;
                </li>
                <li>
                  <b>e) </b>Disponibilização de cotações e feed de notícias;
                </li>
              </ul>

              <p>
                <strong>2.2.</strong> A disponibilização das Plataformas Online
                trata-se de mera conveniência de atendimento disponibilizada
                pela <b>CORRETORA</b> e <b>XPAY</b> aos seus Clientes,
                reservando a estas o direito de a qualquer tempo modificar,
                extinguir e disponibilizar novos serviços aos Clientes,
                aplicando-se a estes novos serviços todas as regras já previstas
                neste Termo, salvo se houver disposição expressa em contrário.
              </p>

              <b>3. CADASTRO E INFORMAÇÕES DO CLIENTE</b>

              <p>
                <strong>3.1.</strong> Para a utilização dos Serviços pelas
                plataformas on-line da <b>CORRETORA</b>, o Cliente deverá
                realizar o seu cadastro digital por meio de uma das plataformas
                da <b>CORRETORA</b>, o qual incluirá a criação de um login e
                senha de acesso, preenchimento das informações solicitadas,
                conforme segue:
              </p>

              <p>
                <strong style="text-decoration: underline"
                  >PESSOA FÍSICA:</strong
                >
              </p>
              <ul>
                <li>Nome Completo</li>
                <li>Data de Nascimento</li>
                <li>Email</li>
                <li>Endereço Residencial Completo</li>
                <li>
                  O carregamento (upload) da imagem (Legível) de um documento de
                  identificação com foto (RG, CNH, RNE, CPF – Com emissão
                  inferior a 10 anos)
                </li>
              </ul>

              <p>
                <strong style="text-decoration: underline"
                  >PESSOA JURÍDICA:</strong
                >
              </p>
              <ul>
                <li>Razão Social</li>
                <li>CNPJ</li>
                <li>E-mail</li>
                <li>
                  Em casos de sociedades limitadas, EIRELIs ou qualquer outra
                  não constituída sob a forma de ações, upload (Carregamento) do
                  Contrato Social Atualizado
                </li>
                <li>
                  Em casos de sociedades constituídas sob a forma de ações,
                  upload do Estatuto Social, com ata de eleição da Diretoria
                  vigente e subscrição das Ações
                </li>
                <li>Upload do Comprovante de Endereço</li>
              </ul>

              <p>
                <strong>3.2.</strong> O Cliente declara estar ciente e concorda
                que deverá apresentar dados verídicos e que retratam a realidade
                dos fatos isentando integral e ilimitadamente de qualquer
                declaração de falsidade eventualmente alegada.
              </p>

              <p>
                <strong>3.4.</strong> O Cliente declara estar ciente que a senha
                de acesso é de uso pessoal, exclusivo e intransferível, os quais
                serão de sua exclusiva responsabilidade zelar para que não haja
                qualquer apropriação e/ou divulgação dos mesmos a (ou para)
                terceiros.
              </p>

              <p>
                <strong>3.5.</strong> Caso o Cliente tome conhecimento de
                apropriação não autorizada de suas informações por terceiros,
                deverá reportar imediatamente à <b>CORRETORA</b> para que esta
                tenha ciência e tome as medidas de segurança cabíveis, conforme
                Política de Privacidade.
              </p>

              <p>
                <strong>3.6.</strong> Até o momento de recebimento da informação
                do Cliente sobre a apropriação não autorizada de seu login e
                senha por terceiros, o Cliente será responsável por toda e
                qualquer informação ou requerimento de operação realizada em seu
                cadastro, bem como das consequências que decorrerem desta
                utilização até a comprovação do reporte do fato à
                <b>CORRETORA</b>.
              </p>

              <p>
                <strong>3.7.</strong> A <b>CORRETORA</b> poderá bloquear e/ou
                suspender o cadastro do Cliente, imotivadamente, sem que assista
                o Cliente qualquer direito de ressarcimento ou indenização,
                quando da ocorrência de fraude, suspeita de lavagem de dinheiro
                ou motivos confidenciais levantados pelo Compliance da
                <b>CORRETORA</b>.
              </p>

              <p>
                <strong>3.8.</strong> O Cliente declara estar ciente que a
                <b>CORRETORA</b> poderá monitorar, por meio do I.P. o local
                geográfico do qual o Cliente realizar os acessos, estando
                autorizada a <b>CORRETORA</b> a bloquear os acessos em caso de
                acesso de localidade estranha ao padrão de utilização do
                Cliente.
              </p>

              <p>
                <strong>3.9.</strong> As informações pessoais do Cliente serão
                utilizadas pela <b>CORRETORA</b> e pela <b>XPAY</b> para
                monitorar o cumprimento deste termo e demais regulamentos
                aplicáveis, bem como para certificar-se do devido cumprimento da
                Legislação vigente e identificar possíveis tentativas de
                práticas classificadas ou que possam ser ao menos consideradas,
                como criminosas, bem como para prevenir qualquer fraude que
                venha ser identificada.
              </p>

              <p>
                <strong>3.10.</strong> Nos termos da cláusula 3.9, o Cliente
                está ciente e concorda que tais informações constantes em seu
                cadastro, bem como outras porventura identificadas pela
                <b>CORRETORA</b>, serão remetidas ao Conselho de Controle de
                Atividades Financeiras – COAF, sempre que necessário e, no caso
                de eventual inadimplemento do pagamento pelos serviços, será
                feito competente apontamento em listas de restrição ao crédito,
                tais como SERASA, SPC ou similares.
              </p>

              <b>4. VALIDADE DO REQUERIMENTO DA OPERAÇÃO</b>

              <p>
                <strong>4.1.</strong> Sempre que desejar realizar uma operação,
                o Cliente, assim considerada a definição na cláusula 3.1 deste
                termo, deverá realizar o preenchimento do formulário disponível
                na plataforma on-line onde os serviços estejam sendo
                solicitados, ou no site próprio da <b>CORRETORA</b> em casos de
                redirecionamento automático do Cliente.
              </p>

              <p>
                <strong>4.2.</strong> A <b>CORRETORA</b> poderá requerer ao
                Cliente o preenchimento de informações adicionais, sempre que
                julgar necessário, podendo em tais casos inclusive condicionar o
                aceite de tais solicitações de operações a entrega e
                fornecimento de tais informações. Nestes casos, as operações
                poderão ultrapassar o prazo divulgado à época do requerimento
                das operações, sem qualquer responsabilização imputada à
                <b>CORRETORA</b> com aplicação de multa por descumprimento
                contratual.
              </p>

              <p>
                <strong>4.3.</strong> Determinados serviços prestados pela
                <b>CORRETORA</b> exigem que o Cliente anexe na plataforma
                on-line os documentos comprobatórios do motivo da operação,
                valor e partes envolvidas os quais estarão sujeitos a aprovação
                da <b>CORRETORA</b>.
              </p>

              <b>5. DAS EXCLUSÕES</b>

              <p>
                <strong>5.1.</strong> Para requerimentos de operações cambiais
                cujo valor em moeda estrangeira ultrapasse o limite individual,
                por operação, de USD 3.000,00 ou o seu equivalente em outra
                moeda estrangeira a <b>CORRETORA</b> poderá exigir o recebimento
                de documentos ou informações adicionais conforme exigidas por
                legislação vigente.
              </p>

              <p>
                <strong>5.2.</strong> Operações realizadas pelo mesmo cliente
                que atinjam outros limites legais, contudo, não alcançando
                individualmente o valor supramencionado, poderão ser suspensas
                pela <b>CORRETORA</b>, ficando tais operações condicionadas ao
                fornecimento de outras informações adicionais julgadas
                necessárias e devidamente informadas ao Cliente quando de sua
                ocorrência.
              </p>

              <p>
                <strong>5.3.</strong> Havendo recusa do Cliente na
                complementação ou entrega das informações iniciais prestadas, a
                operação não será finalizada, realizando-se, por conseguinte,
                sua retirada do sistema, sumariamente.
              </p>

              <b>6. DAS AUTORIZAÇÕES</b>

              <p>
                <strong>6.1.</strong> O Cliente autoriza a <b>CORRETORA</b> e a
                <b>XPAY</b> a enviarem para todos os seus meios de comunicação,
                eletrônicos ou não, que existam ou venham a existir, tais como,
                mas não exclusivamente, e-mail, SMS e Push, informações,
                promoções, avisos e mensagens referentes ao objeto social da
                empresa.
              </p>

              <p>
                <strong>6.2.</strong> O Cliente está ciente que a
                <b>CORRETORA</b> e a <b>XPAY</b> poderão a qualquer tempo, e
                sempre que se fizer necessário, acessar as informações sobre
                operações realizadas no mercado de câmbio, por meio de
                informações disponibilizadas pelo Banco Central do Brasil,
                objetivando o acompanhamento das operações de câmbio do Cliente,
                bem como praticar todos os atos necessários para proceder com o
                registro e inclusão de dados necessários às referidas transações
                neste sistema, nos termos da Circular 3.814, de 07 de dezembro
                de 2016 – BACEN, bem como realize, em nome do Cliente, registros
                de RDE-IED (Registros Declaratórios Eletrônicos de Capitais
                Estrangeiros, Módulo Investimentos Estrangeiros Diretos),
                ficando, portanto, autorizada a <b>CORRETORA</b> e a
                <b>XPAY</b> a praticarem todos os atos necessários para proceder
                com o registro e inclusão de dados às referidas transações.
              </p>

              <p>
                <strong>6.3.</strong> O Cliente está ciente que, conforme a
                regulamentação em vigor emitida pelo Conselho Monetário Nacional
                e demais Autoridades, determinados serviços solicitados pelo
                declarante à <b>CORRETORA</b> poderão demandar a formalização
                por meio de assinatura de contratos de câmbio. A formalização da
                operação será através do envio do contrato de câmbio por correio
                ou meio eletrônico para operações até USD50.000,00 (cinquenta
                mil dólares americanos). Para operações acima de USD50.000,00
                (cinquenta mil dólares americanos) será necessária assinatura
                eletrônica do contrato de câmbio ou outorga de poderes à
                <b>CORRETORA</b> declarada na ficha cadastral.
              </p>

              <b>7. DIREITOS DE TERCEIROS</b>

              <p>
                <strong>7.1.</strong> Este termo não confere a quaisquer
                terceiros qualquer benefício ou direito de exigir o cumprimento
                de quaisquer itens deste Termo.
              </p>

              <b>8. MODIFICAÇÃO DO TERMO</b>

              <p>
                <strong>8.1.</strong> A <b>CORRETORA</b> e a <b>XPAY</b> se
                reservam ao direito de a qualquer tempo, modificar as cláusulas
                e condições deste termo, devendo o Cliente, em qualquer
                hipótese, ler e concordar com suas condições e obrigações
                previstas, condição indissociável para realização de tais
                operações cambiais.
              </p>

              <b>9. DA VIGÊNCIA DO TERMO</b>

              <p>
                <strong>9.1.</strong> O presente termo tem vigência por
                indeterminado, sendo sua aceitação ratificada pelo cliente a
                cada operação realizada sob sua vigência.
              </p>

              <b>10. DO SIGILO E PRIVACIDADE</b>

              <p>
                <strong>10.1.</strong> Aplica-se à utilização das Plataformas
                On-line a Política de Privacidade da <b>CORRETORA</b> e da
                <b>XPAY</b>, a qual o Cliente por meio da aceitação do presente
                termo também declara ter pleno conhecimento e estar de acordo.
              </p>

              <b
                >11. DA LEI GERAL DA PROTEÇÃO DE DADOS E FORNECIMENTO DE
                INFORMAÇÕES DO CLIENTE</b
              >

              <p><strong>11.1.</strong> O Cliente está ciente e de acordo:</p>
              <p>
                <strong>11.1.1.</strong> Que seus dados fornecidos à
                <b>CORRETORA</b> e a <b>XPAY</b> poderão ser encaminhados para
                serem tratados por terceiros (Operadores de Dados Pessoais)
                contratados pela <b>CORRETORA</b> ou pela <b>XPAY</b> para
                prestação de serviços relacionados às Plataformas On-line da
                <b>CORRETORA</b> e da <b>XPAY</b> que exijam o tratamento de
                dados do Cliente;
              </p>
              <p>
                <strong>11.1.2.</strong> Com a coleta de seus dados de
                navegação, como visualização de páginas e conversões, via
                cookies, tags, pixel, GPS e outras tecnologias semelhantes, nas
                Plataformas On-line.
              </p>
              <p>
                <strong>11.1.2.1</strong> Em relação ao site a poderá ser
                parcialmente desativada pelo cliente, com exceção de tecnologias
                que garantam o funcionamento da plataforma, no seu dispositivo
                e/ou navegador, ficando a cargo do cliente desabilitá-las.
              </p>
              <p>
                <strong>11.1.2.2</strong> Referente aos Aplicativos, não é
                possível a desativação das tecnologias mencionadas com exceção
                do GPS.
              </p>

              <p>
                <strong>11.2.</strong> Os dados poderão também ser
                compartilhados pela <b>CORRETORA</b> e pela <b>XPAY</b> nas
                seguintes hipóteses:
              </p>
              <p>
                <strong>11.2.1.</strong> Por obrigação legal ou decisão de
                autoridade competente;
              </p>
              <p>
                <strong>11.2.2.</strong> Caso a divulgação for necessária para
                prevenir danos ou prejuízos à <b>CORRETORA</b>, Cliente ou a
                terceiros;
              </p>
              <p>
                <strong>11.2.3.</strong> Em caso de suspeita de prática de
                ilícitos às Autoridades Públicas;
              </p>
              <p>
                <strong>11.2.4.</strong> Para outras empresas do grupo econômico
                <b>CORRETORA</b>;
              </p>
              <p>
                <strong>11.2.5.</strong> Para parceiros comerciais da
                <b>CORRETORA</b>.
              </p>

              <p>
                <strong>11.3.</strong> Além das condições acima, em relação à
                utilização de dados dos clientes, ao aderir ao presente termo,
                aplica-se à utilização das Plataformas On-line o Acordo de
                Utilização de Dados da <b>CORRETORA</b> e da <b>XPAY</b>, o qual
                o Cliente por meio da aceitação do presente termo também declara
                ter pleno conhecimento e estar de acordo.
              </p>

              <p>
                <strong>11.4.</strong> Ao utilizar as Plataformas Online, o
                cliente dá seu consentimento para receber por meio destas
                notificações (push) referentes a promoções, conteúdo útil e
                informações gerais do Grupo <b>CORRETORA</b>.
              </p>

              <b>12. LEI E JURISDIÇÃO</b>

              <p>
                <strong>12.1.</strong> Este termo entra em vigor na data de seu
                arquivamento em cartório, permanecendo-se vigente até que haja
                sua expressa revogação ou alteração.
              </p>

              <p>
                Aplica-se a este Termo as Leis da República Federativa do
                Brasil, elegendo-se o Foro da Capital de São Paulo para dirimir
                quaisquer dúvidas ou questionamentos que dele se façam
                necessários, renunciando-se a qualquer outro, por mais
                privilegiado que seja.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
